import React from "react";
import Snackbar from "@material-ui/core/Snackbar";

export default function AlertComponent({ open, color, onClose, message }) {
  return (
    <Snackbar open={open} color={color} onClose={onClose} message={message} />
  );
}
